import React from "react";
import { useTranslation } from "react-i18next";
import Link from "next/link";

import { urlifyPseudo } from "@audacia-hq/shared/utils";

import { Notification } from "../../models/notification";
import { useExpert } from "../../context/ExpertContext";

interface Props {
  notification: Notification;
  icon?: React.ReactNode;
}

const QueueNotif: React.FC<Props> = ({ notification, icon }) => {
  const { t } = useTranslation("common");
  const { expertIdentifiers } = useExpert();

  const { expertUid, ...fields } = JSON.parse(notification.metadata) || {};
  const expertIdentifier = expertIdentifiers[expertUid];

  const metadata = {
    expertPseudo: expertIdentifier?.pseudo || t("anExpert"),
    ...fields,
  };

  return (
    <div className="flex flex-col gap-1">
      {expertIdentifier ? (
        <div>
          <Link
            href={`/expert-detail/${urlifyPseudo(expertIdentifier.pseudo)}`}
            className="flex space-x-3 items-center text-blue-500 hover:text-blue-600"
          >
            <div>{icon}</div>
            <div>
              <>
                {t(
                  `notifications.${notification.notificationType}.title`,
                  metadata,
                )}
              </>
            </div>
          </Link>
        </div>
      ) : (
        <span><>{t(`notifications.${notification.notificationType}.title`, metadata)}</></span>
      )}

      <span className="text-gray-700 text-sm">
        <>
          {t(
            `notifications.${notification.notificationType}.body`,
            metadata,
          )}
        </>
      </span>
    </div>
  );
};

export default QueueNotif;
